<a
  appClickStopPropagation
  (click)="toggleMenu()"
  fxLayout="column"
  fxLayoutAlign="center start"
  fxLayoutAlign.gt-sm="center center"
  class="menu-item menu-item-animation"
  [routerLink]="basePath + '/' + item.link"
  [ngClass]="{
    'active': isItemLinkActive(item, children)
  }"
>
  <div
    class="menu-item-text menu-item-text-animation"
  >
    <span
      [ngClass]="{'parent-menu-item-text-wrapper': children.length > 0}"
    >
      {{ 'shared.menu_links.' + item.text | translate }}
    </span>
  </div>
</a>



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-item/menu-item.component.html